import {findObjectClosestToDate} from '../feedParser'
import {LOCAL_KEY} from '../../constants'

export const feedValuesClosestToDate = (date, dtnFeedData, basisValues) => {
  const liveCattle = findObjectClosestToDate(
    dtnFeedData[LOCAL_KEY.dtnLiveCattle]['all'],
    date,
  )
  const cdn = findObjectClosestToDate(
    dtnFeedData[LOCAL_KEY.dtnCDN]['all'],
    date,
  )
  const basisValue = findObjectClosestToDate(basisValues, date)

  return {
    liveCattle,
    cdn,
    basisValue,
  }
}



// WEBPACK FOOTER //
// ./src/helpers/calculators/sharedCalculations.js